import { type ThunkAction } from 'redux-thunk';
import { createAction } from '@wix/communities-blog-client-common';
import { normalizePosts } from '../services/post-utils';
import { getCategoryIds } from '../store/categories/categories-selectors';
import type { AppState, NormalizedPost } from '../types';

export const SET_POSTS = 'posts/SET';

const setNormalizedPosts = createAction(SET_POSTS);

const setPosts =
  (posts: any = []): ThunkAction<NormalizedPost[], AppState, any, any> =>
  (dispatch, getState) => {
    const normalizedPosts = normalizePosts({
      posts,
      blogCategoryIds: getCategoryIds(getState()),
    });
    dispatch(setNormalizedPosts(normalizedPosts));
    return normalizedPosts;
  };

export default setPosts;
